import { Autocomplete, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";

export const optionsGuideCode = [
	{ Code: "I", Name: "Entry" },
	{ Code: "O", Name: "Delivery" },
];

type Props = {
	label: string;
	value: string | null;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const GuideTypeSelector = ({
	label,
	value,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedType =
		optionsGuideCode.find((code) => code.Code === value) || null;

	return (
		<Autocomplete
			id="guide-type-selector"
			clearOnEscape
			autoHighlight
			options={optionsGuideCode}
			getOptionLabel={(option) => option.Name}
			renderInput={(params) => (
				<TextField
					{...params}
					required={required}
					label={label}
					variant="outlined"
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					size="small"
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.Code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
